module.exports = __webpack_public_path__ + "static/media/screenshot 4.72e10245.jpg";